/* @flow */

import * as React from 'react';
import {RadioGroupContext} from './radio-group';

import './radio.css';

type Props = {
    disabled?: boolean,
    value: string,
    children?: React.Node,
};

export class Radio extends React.Component<Props> {
    render() {
        return (
            <RadioGroupContext.Consumer>
                {({name, selectedValue, inline, onChange}) => {
                    const checked = this.props.value === selectedValue;
                    const radioId = `${name}-${this.props.value}`;

                    return (
                        <label styleName={inline ? 'radio--inline' : 'radio'} htmlFor={radioId}>
                            <input
                                id={radioId}
                                name={name}
                                type='radio'
                                role='radio'
                                checked={checked}
                                aria-checked={checked}
                                disabled={this.props.disabled}
                                onChange={(e) => this.handleChange(e, onChange)}
                            />
                            <span>{this.props.children}</span>
                        </label>
                    );
                }}
            </RadioGroupContext.Consumer>
        );
    }

    handleChange = (e: SyntheticInputEvent<*>, onChange: Function) => {
        e.stopPropagation();

        onChange(this.props.value);
    };
}
